import NoDataAvailableWithIcon from '../../common/charts/NoDataAvailableWithIcon';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import React from 'react';

export const TicketListHeader = ({ title, description, freshdeskTickets, classes, closed }) => {
  return (
    <div>
      <h1 className={classNames(classes.freshdeskHeader, (closed && classes.closedHeader))}>{title}</h1>
      {!freshdeskTickets || freshdeskTickets.length === 0
        ? <NoDataAvailableWithIcon customText={<FormattedMessage id="freshdesk.no.tickets"
                                                                 defaultMessage="You don't have any open tickets" />} />
        : <p className={classes.description}>{description}</p>}
    </div>
  );
};

TicketListHeader.propTypes = {
  title: PropTypes.object.isRequired,
  description: PropTypes.object.isRequired,
  freshdeskTickets: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
};